import { useQuery } from "@tanstack/react-query";
import { fetchApiGet } from "../utils";

// ── Commodities ────────────────────────────────────────────────────

export interface AgtechCommodity {
  id: string;
  name: string;
  commodity_id: string;
}

export interface AgtechCommoditiesResponse {
  data: AgtechCommodity[];
}

export function useListAgtechCommodities() {
  return useQuery({
    queryKey: ["agtech", "commodities"],
    queryFn: () => fetchApiGet<AgtechCommodity[]>("agtech/commodities"),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 10, // 10 minutes
    retry: 1,
  });
}
